// @flow
import moment from 'moment';

import { type TrackingPayload } from 'Tracking/tracking-api/useTracking';
import {
  PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD,
  PRICE_COUNTER_PROPOSAL_THRESHOLD,
} from 'Store/booking/proposals/constants';

export const getDepartureDate = ({ date, duration, format, unit }: *): * => {
  return moment(date, format)
    .add(duration, unit)
    .format(format);
};

export const hasPriceSuggestions = (proposal: Proposal, appContext: AppContext): boolean =>
  proposal &&
  proposal.price &&
  proposal.price.gap > 0 &&
  (proposal.price.gap < PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD ||
    (appContext.isSeller && proposal.price.gap >= PRICE_COUNTER_PROPOSAL_THRESHOLD));

type Props = {
  proposal?: Proposal,
  appContext: AppContext,
  suggestions: BookingSuggestions,
  disableAlternativePrice?: boolean,
};
export const getSuggestionsTrackingData = ({
  proposal,
  suggestions,
  appContext,
  disableAlternativePrice,
}: Props): TrackingPayload => {
  const hasDateSuggestion = suggestions.dates.length > 0;
  const hasResortSuggestion = suggestions.resorts.length > 0;
  const hasDurationSuggestion = suggestions.durations.length > 0;
  const hasPriceSuggestion =
    !disableAlternativePrice && proposal && hasPriceSuggestions(proposal, appContext);

  const labelGA = `displayCounterProposals${hasPriceSuggestion ? '_rate10' : ''}${
    hasDateSuggestion ? '_date' : ''
  }${hasResortSuggestion ? '_resort' : ''}${hasDurationSuggestion ? '_duration' : ''}`;

  return { labelGA };
};
